/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { checkSettingAccess, checkSideBarAccess, checkMarketingAccess } from '../utils/tools';

class PrivateRoute extends Component {
  render() {
    const { isAuthenticated, path, exact = false } = this.props;
    const ComponentToRender = this.props.component;
    return (
      <Route
        exact={exact}
        path={path}
        render={() =>
          isAuthenticated === true ? (
            checkSettingAccess(this.props, path) ? (
              <Redirect
                to={{
                  pathname: '/settings'
                }}
              />

            ) : checkMarketingAccess(this.props, path) ? (
              <Redirect
                to={{
                  pathname: '/marketing'
                }}
              />
            ) : (checkSideBarAccess(path) && path !== '/') ? (
              <Redirect
                to={{
                  pathname: '/'
                }}
              />
            ) : (
              <ComponentToRender />
            )
          ) : (
            <Redirect
              to={{
                pathname: '/login'
              }}
            />
          )
        }
      />
    );
  }
}

export default PrivateRoute;
